import { type VariantProps, cva } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-stone-400',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-stone-900 text-white dark:bg-stone-100 dark:text-stone-900',
        outline: 'border-stone-300 bg-transparent text-stone-700 dark:border-stone-700 dark:text-stone-300',
        selected: 'border-transparent bg-emerald-600 text-white',
      },
    },
    defaultVariants: { variant: 'outline' },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />
}
